import { formatDeliveryOrServiceWindow } from '../../../utils/utils';
import { getDisplayServiceLevel } from '../../../../shared/serviceLevelUtils';

const CONSIGNEE_LABEL_LIST = [
  { label: "Consignee Name", fieldName: "displayCustomerName" },
  { label: "Consignee Address", fieldName: "address" },
  { label: "City", fieldName: "city" },
  { label: "Customer Acc #", fieldName: "displayCustomerCode" },
  { label: "Consignee State", fieldName: "state" },
  { label: "Consignee Zip", fieldName: "zip" },
  { label: "Customer Phone", fieldName: "customerPhone" },
  { 
    label: "Delivery Window", 
    fieldName: "deliveryWindow",
    formatter: formatDeliveryOrServiceWindow 
  },
  {
    label: "Priority",
    fieldName: "priority",
    needsServiceLevelList: true,
    formatter: (priority, serviceLevelList) =>
      getDisplayServiceLevel(priority, serviceLevelList),
  },
];

const SHIPPER_LABEL_LIST = [
  { label: "Shipper Name", fieldName: "shipperName" },
  { label: "Shipper Address", fieldName: "shipperAddress" },
];

const LOADING_ZONE_LIST = ["F", "M", "R", "T"];
const TAIL_LOADING_ZONE = "T"

const MESSAGES= {
  disabledSubmit: "Cannot Add Completed Pro to Active Dispatch",
  duplicateProInManifest: 'Cannot add the same pro to the manifest again',
}

export {
  CONSIGNEE_LABEL_LIST,
  SHIPPER_LABEL_LIST,
  LOADING_ZONE_LIST,
  TAIL_LOADING_ZONE,
  MESSAGES,
};
